import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "checkbox__input-container" }
const _hoisted_2 = ["name", "id", "checked", "disabled"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-checkbox',
},
  __name: 'checkbox',
  props: {
    id: {},
    label: {},
    name: {},
    errorMessage: {},
    checked: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:checked", "change"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

// Define emits
const emit = __emit;

const value = useVModel(props, 'checked', emit);

// Use the IdGenerator composable
const { inputId } = useIdGenerator(props.id);

// Handle checkbox change
function handleCheckboxChange(event: Event) {
  const target = event.currentTarget as HTMLInputElement;
  value.value = target.checked;
  emit('change', target.checked);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input checkbox", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        type: "checkbox",
        name: __props.name,
        id: _unref(inputId),
        checked: __props.checked,
        disabled: __props.disabled,
        onChange: handleCheckboxChange
      }, null, 40, _hoisted_2),
      _createElementVNode("label", {
        class: _normalizeClass(["checkbox__label", { 'checkbox__label--disabled': __props.disabled }]),
        for: _unref(inputId)
      }, _toDisplayString(__props.label), 11, _hoisted_3)
    ]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})